import { CellProps } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Columns/Cells/type';
import {
  FormInputNumber,
  FormInputNumberProps,
} from '@moneyforward/ap-frontend-components';
import { memo } from 'react';
import { FieldValues } from 'react-hook-form';

export type Props<TFieldValues extends FieldValues> =
  {} & FormInputNumberProps<TFieldValues> & CellProps;

const InnerRateCell = <TFieldValues extends FieldValues>({
  control,
  name,
  ...rest
}: Props<TFieldValues>) => {
  return (
    <FormInputNumber<TFieldValues> control={control} name={name} {...rest} />
  );
};
InnerRateCell.displayName = 'InnerRateCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const RateInputCell = memo(InnerRateCell) as typeof InnerRateCell;
